<template>
  <div class="container">
    <div class="content">
      <div class="left">
        <div class="list-content">
          <div class="list" v-for="(item, index) in list" :key="index">
            <div class="title">{{ item.resTypeName }} ({{ item.resList ? item.resList.length : 0 }}个)</div>
            <div
              class="child"
              :key="it.id"
              v-for="it in item.resList"
              @click="
                previewChange(item.resType, it, false)
                student = null
              "
              :class="{ selected: file && file.newId === it.id && fileType === item.resType }"
            >
              <img :src="getIcon(item.resType)" alt="" srcset="" />
              <a-tooltip placement="topLeft" class="name">
                <template slot="title">
                  {{ it.name }}
                </template>
                <span>{{ it.name }}</span>
              </a-tooltip>
              <div class="action">
                <div
                  v-if="isTeachPer && item.resType === 'creator'"
                  class="teach"
                  @click.stop="handleTeach(item.resType, it)"
                >
                  <div>
                    <a-tooltip placement="top" overlayClassName="tooltip_course">
                      <template slot="title">
                        <span> {{ teachInfo.id === it.id && teachInfo.isTeach ? '结束示教' : '示教' }}</span>
                      </template>
                      <img
                        class="icon_exit_teach"
                        v-if="teachInfo.id === it.id && teachInfo.isTeach"
                        src="@/assets/icons/icon_exit_teach.png"
                        alt="icon_exit_teach"
                      />
                      <img class="icon_teach" v-else src="@/assets/icons/icon_teach.png" alt="icon_teach" />
                    </a-tooltip>
                  </div>
                </div>
                <div
                  class="broadcasting"
                  v-if="
                    previewData &&
                      previewData.id === it.id &&
                      previewData.resType === item.resType &&
                      previewData.control
                  "
                >
                  <a-tooltip placement="top" overlayClassName="tooltip_course">
                    <template slot="title">
                      <span>结束播控</span>
                    </template>
                    <img
                      class="icon-close"
                      @click="close($event, item.resType, it)"
                      src="@/assets/icons/icon_close.png"
                      alt=""
                    />
                  </a-tooltip>
                </div>
                <div class="broadcasting" v-else>
                  <a-tooltip placement="top" overlayClassName="tooltip_course">
                    <template slot="title">
                      <span>播控</span>
                    </template>
                    <img
                      class="icon-play"
                      @click="play($event, item.resType, it)"
                      src="@/assets/icons/icon_bf.png"
                      alt=""
                      srcset=""
                    />
                  </a-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="close-button" @click="closeClass">
          <div>
            <img src="@/assets/icons/icon_js.png" alt="" srcset="" />
            结束课程
          </div>
        </div>
      </div>
      <div class="right">
        <a-tabs v-model="tabKey" @change="callback">
          <a-tab-pane v-if="fileType != 'software'" :key="1" tab="课程讲解">
            <Preview
              v-if="tabKey === 1"
              ref="preview"
              class="preview-container"
              :typeName="fileType"
              :subTypeName="subTypeName"
              :isClass="true"
              :file="file"
            />
          </a-tab-pane>
          <a-tab-pane :key="2" tab="监控视图">
            <div
              class="monitor-attempts"
              v-if="
                previewData &&
                  file &&
                  fileType === previewData.resType &&
                  file.newId == previewData.id &&
                  pagination.total > 0
              "
            >
              <div class="data-overview" v-if="!student">
                <div class="title">数据概览</div>
                <div class="overview">
                  <div>
                    <img src="@/assets/icons/icon_1.png" alt="" srcset="" />
                    <div>
                      <div>上课时长</div>
                      <div>
                        <b class="number"> {{ lessonMonitorData.lectureDuration }} </b>
                      </div>
                    </div>
                  </div>
                  <div>
                    <img src="@/assets/icons/icon_2.png" alt="" srcset="" />
                    <div>
                      <div>播控次数</div>
                      <div>
                        <b class="number"> {{ lessonMonitorData.playResCount }} </b> 次
                      </div>
                    </div>
                  </div>
                  <div>
                    <img src="@/assets/icons/icon_3.png" alt="" srcset="" />
                    <div>
                      <div>班级总人数</div>
                      <div>
                        <b class="number"> {{ lessonMonitorData.classStudentCount }} </b> 人
                      </div>
                    </div>
                  </div>
                  <div>
                    <img src="@/assets/icons/icon_4.png" alt="" srcset="" />
                    <div>
                      <div>在线实训人数</div>
                      <div>
                        <b class="number"> {{ lessonMonitorData.trainingList.length }} </b> 人
                      </div>
                    </div>
                  </div>
                  <div>
                    <img src="@/assets/icons/icon_5.png" alt="" srcset="" />
                    <div>
                      <div>未实训人数</div>
                      <div>
                        <span
                          ><b class="number"> {{ lessonMonitorData.notTrainingList.length }} </b> 人</span
                        >
                        <span v-if="lessonMonitorData.notTrainingList.length > 0" @click="unonlineVisible = true">
                          更多
                          <img src="@/assets/icons/icon_jt.png" alt="" srcset="" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="title">实训查看</div>
                <div class="review">
                  <div
                    class="student"
                    v-for="item in lessonMonitorData.trainingList.slice(
                      pagination.pageSize * (pagination.page - 1),
                      pagination.pageSize * pagination.page
                    )"
                    :key="item.id"
                  >
                    <div class="student-cover">
                      <img :class="'img-cover'" src="@/assets/img/bj_review.png" alt="" srcset="" />
                      <div class="hover"><a-button type="primary" @click="review(item)">实时查看 > </a-button></div>
                    </div>
                    <div class="name">{{ item.name }}</div>
                  </div>
                </div>
                <Pagination class="list-pagination" :pagination.sync="pagination" />
              </div>
              <div class="live-view" v-else>
                <img class="close-view" src="@/assets/icons/icon_gb.png" @click="closeReview" />
                <div class="title">
                  <span /><b>{{ student.name }} — 实操实时画面</b>
                </div>
                <video ref="liveVideo" controls autoplay playsinline></video>
              </div>
            </div>
            <div class="no-monitor-attempts" v-else-if="fileType === 'software'">
              <img src="@/assets/img/pic_bokong.png" alt="" srcset="" />
              <div>请先开启播控</div>
              <div>开启后可对监控视图查看</div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <a-modal
      class="unonlineModal"
      :visible="unonlineVisible"
      @ok="unonlineVisible = false"
      @cancel="unonlineVisible = false"
    >
      <div class="title">未实训人数 ({{ lessonMonitorData.notTrainingList.length }}<span class="small">人</span>)</div>
      <div class="unonlineStudent">
        <span :title="item.name" v-for="item in lessonMonitorData.notTrainingList" :key="item.id">
          {{ item.name }}
        </span>
      </div>
    </a-modal>
    <TipModal
      :okText="'我已知晓'"
      :className="['nocancel']"
      :visible="noControlVisible"
      @ok="closeNoControlModal"
      :desc="
        `<p></p><p><b>请先开启播控</b></p>
        <p class='placeholder'>开启后可对监控视图查看</p>`
      "
    />
    <TipModal
      :okText="'我已知晓'"
      :className="['nocancel']"
      :visible="confirmMsg.visible"
      @ok="confirmMsg.visible = false"
      :desc="`<p></p><p><b>${confirmMsg.desc}</b></p>`"
      @cancel="confirmMsg.visible = false"
    />
    <XRInfoModal :visible.sync="visible" />
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import {
  // lessonClose,
  lessonDetail,
  lessonMonitor,
  prepareLessonDetail
} from '@/api/lesson'
import cookie from 'js-cookie'
import { vrClicent } from '@/utils/vrClient'
import Preview from '@/components/preview/index'
import { getIcon } from '@/utils/other'
import Pagination from '@/components/pagination/index.vue'
import TipModal from '@/components/tipModal/index.vue'
import XRInfoModal from '@/components/XRInfoModal/index'

export default {
  components: {
    TipModal,
    Preview,
    Pagination,
    XRInfoModal
  },
  watch: {},
  data() {
    return {
      list: [],
      tabKey: 1,
      timer: null,
      student: null,
      id: undefined,
      file: undefined,
      getIcon: getIcon,
      client: undefined,
      fileType: undefined,
      webSockerTimer: null,
      unonlineVisible: false,
      previewData: {
        id: undefined,
        resType: undefined,
        control: false
      }, // 当前预览资源
      closeControlVisible: false, // 关闭播控弹窗
      // controlData: controlData, // 当前控制资源
      lessonMonitorData: {
        classStudentCount: 0,
        lectureDuration: undefined,
        notTrainingList: [],
        playResCount: 0,
        trainingList: []
      },
      pagination: {
        page: 1,
        pageSize: 12,
        total: 0,
        hideOnSinglePage: true
      },
      teachInfo: {
        id: '',
        isTeach: false
      },
      confirmMsg: {
        visible: false,
        desc: ''
      },
      isTeachPer: false,
      visible: false,
      subTypeName: ''
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    callback(key) {
      this.student = null
      if (key === 2) {
        if (this.fileType !== this.previewData.resType) {
          this.tabKey = 1
          this.noControlVisible = true
          return
        }
        this.tabKey = this.previewData.control ? key : 1
        if (this.file.newId === this.previewData.id && this.previewData.control) {
          this.tabKey = 2
        } else {
          this.tabKey = 1
          this.noControlVisible = true
        }
      }
    },
    closeNoControlModal() {
      this.noControlVisible = false
      this.$forceUpdate()
    },
    // 切换当前资源状态
    previewChange(resType, obj, control, subTypeName) {
      if (control && this.previewData && this.previewData.control && this.previewData.id != obj.id) {
        this.confirmMsg = {
          visible: true,
          desc: '请先关闭当前播控资源'
        }
        return
      }
      if (this.fileType === 'model' && this.file.newId != obj.id) {
        this.$refs.preview.closeModel()
        if (this.previewData.id !== obj.id) {
          // this.previewData.id = obj.id
        } // 限制重复点击
      }
      this.tabKey = resType === 'software' ? 2 : 1
      this.fileType = resType
      this.file = cloneDeep(obj)
      this.file.newId = obj.id
      this.file.id = this.getOriginalId(obj.id)
      this.subTypeName = obj.subTypeName
      if (resType !== 'creator' && obj.files.length === 0) {
        this.$message.error('该资源暂无播控内容！')
        return
      }
      if (!control) return
      this.previewData = Object.assign(cloneDeep(obj), {
        control: false,
        resType
      })
    },
    // 播控当前资源
    play(el, resType, obj) {
      el.stopPropagation()
      // 示教互斥
      if (this.teachInfo.isTeach) {
        this.confirmMsg = {
          visible: true,
          desc: '示教中不可进行播控'
        }
        return
      }
      if (this.previewData && this.previewData.control) {
        this.confirmMsg = {
          visible: true,
          desc: '请先关闭当前播控资源'
        }
        return
      }
      this.previewChange(resType, obj, true)
      const data = {
        opcode: 'event',
        message_id: '306',
        data: {
          name: 'OpenRes',
          content: {
            res_id: this.getOriginalId(obj.id),
            name: 'OpenRes',
            res_type: resType,
            source_type: obj.sourceType || 'school',
            sub_res_type: obj.subTypeName || '',
            roomId: this.roomId,
            teacher_id: cookie.getJSON('user_infor').id,
            open_type: 'play'
          }
        }
      }
      vrClicent.sendMessage(data)
    },
    // 关闭当前资源
    close(el, stop) {
      if (this.previewData.resType !== 'software' && this.fileType !== 'software') this.tabKey = 1
      if (stop) el.stopPropagation()
      const closeResData = {
        opcode: 'event',
        message_id: '503',
        data: {
          name: 'CloseRes',
          content: {
            name: 'CloseRes',
            roomId: this.roomId,
            open_type: 'play'
          }
        }
      }
      vrClicent.sendMessage(closeResData)
      if (this.student) this.closeReview()
      // this.previewData.id = undefined
      // this.previewData.resType = undefined
      this.previewData.control = false
    },
    // 关闭当前课程
    closeClass() {
      // 关闭播控，示教
      if (this.previewData.control) this.close('', false)
      if (this.teachInfo.isTeach) this.closeTeach()

      const removeRomeData = {
        opcode: 'quit',
        message_id: '888',
        body: {
          name: 'quit'
        }
      }
      vrClicent.sendMessage(removeRomeData)
      // lessonClose({
      //   id: this.roomId
      // }).then(res => {
      //   if (res.code != 200) return
      this.$message.success('当前课程已关闭！')
      this.$router.push({
        name: 'lessonList'
      })
      // })
    },
    // 查看当前学生实训
    review(obj) {
      obj.id = this.getOriginalId(obj.id)
      this.student = obj
      this.$nextTick(() => {
        const video = this.$refs.liveVideo
        const data = {
          opcode: 'message',
          message_id: '666',
          data: {
            to: 'student_' + obj.id,
            name: 'webRtcMsg',
            body: {
              to: 'student_' + obj.id,
              name: 'webRtcMsg',
              type: 'creatpeer',
              from: 'teacher_' + cookie.getJSON('user_infor').id
            }
          }
        }
        vrClicent.getVideo(video)
        vrClicent.sendMessage(data)
      })
    },
    // 关闭当前学生实训
    closeReview() {
      const data = {
        opcode: 'message',
        message_id: '669',
        data: {
          to: 'student_' + this.student.id,
          name: 'webRtcMsg',
          body: {
            to: 'student_' + this.student.id,
            name: 'webRtcMsg',
            type: 'closepeer',
            from: 'teacher_' + cookie.getJSON('user_infor').id
          }
        }
      }
      vrClicent.sendMessage(data)
      vrClicent.closeRTCPeerConnection()
      this.student = null
    },
    getLessonMonitor() {
      lessonMonitor({
        id: this.roomId
      }).then(res => {
        if (res.code != 200) return
        const list = [...res.data.trainingList]
        const domList = document.getElementsByClassName('img-cover')
        if (domList.length > 0) {
          list.forEach((item, index) => {
            item.cover =
              'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/pt/monitor/' +
              this.roomId +
              '_' +
              item.id +
              '.jpg' +
              `?${Date.now()}`

            if (!domList[index]) return
            domList[index].src = item.cover
          })
        }
        this.lessonMonitorData = {
          trainingList: list,
          playResCount: res.data.playResCount,
          lectureDuration: res.data.lectureDuration,
          notTrainingList: res.data.notTrainingList,
          classStudentCount: res.data.classStudentCount
        }
        this.pagination.total =
          this.lessonMonitorData && this.lessonMonitorData.trainingList ? this.lessonMonitorData.trainingList.length : 0
        this.previewData.control = res.data.trainingList.length > 0
      })
    },
    getLessonDetail() {
      lessonDetail({
        id: this.roomId
      }).then(res => {
        if (res.code != 200) return
        prepareLessonDetail({
          append_file: true,
          id: res.data.prepareLessonId
        }).then(res => {
          this.list = res.data.resInfo
          this.list.forEach(item => {
            if (Array.isArray(item.resList)) {
              item.resList.forEach(resItem => {
                resItem.id = resItem.sourceType + '_' + resItem.id
              })
            }
          })
          if (!this.list.length) return
          this.previewChange(this.list[0].resType, this.list[0].resList[0], false)
        })
      })
    },
    // 示教
    handleTeach(type, obj) {
      // 播放互斥
      if (this.previewData.control) {
        this.confirmMsg = {
          visible: true,
          desc: '播控中不可进行示教'
        }
        return
      }

      // 只能同时示教一个资源
      if (this.teachInfo.id && this.teachInfo.id !== obj.id) {
        this.confirmMsg = {
          visible: true,
          desc: '当前仅支持开启一个示教'
        }
        return
      }

      // 关闭示教
      if (this.teachInfo.id === obj.id && this.teachInfo.isTeach) {
        this.closeTeach(obj)
        return
      }
      // 开启示教
      const userType = cookie.getJSON('user_type').join(',')
      const data = {
        data: Object.assign(cookie.getJSON('user_infor'), {
          resId: this.getOriginalId(obj.id),
          token: localStorage.token,
          roles: cookie.getJSON('user_type'),
          type: 'teach',
          roomId: this.roomId,
          playerId: Number(obj.playerInfo.find(playItem => playItem.playerType === 'teach').playerId), // playerType: 1.other 3D实训软件 2.open_res 播控(研创课件） 3.teach 示教(研创课件）
          source_type: obj.sourceType || 'school',
          school_type: userType.includes('external') ? 2 : 1 // 1校内 2校外
        })
      }
      this.teachInfo = Object.assign(this.teachInfo, {
        id: obj.id,
        isTeach: false
      })
      vrClicent.getStartupState(() => {
        this.$message.success('系统启动中...')
        // 示教成功回调
        this.teachInfo.isTeach = true
        // 通知学生端
        const scoketDataStu = {
          opcode: 'event',
          message_id: '306',
          data: {
            name: 'OpenRes',
            content: {
              res_id: this.getOriginalId(obj.id),
              name: 'OpenRes',
              res_type: type,
              roomId: this.roomId,
              teacher_id: cookie.getJSON('user_infor').id,
              open_type: 'teach',
              source_type: obj.sourceType || 'school'
            }
          }
        }
        vrClicent.sendMessage(scoketDataStu)
      })
      const success = () => {
        // this.$message.success('系统启动中...')
      }

      // 一键打开应用程序
      // 检测用户的设备是否是Windows系统
      if (/windows|win32/i.test(navigator.userAgent)) {
        // 检测用户的浏览器是否能使用universalLink
        let openApp = false
        const userAgent = navigator.userAgent
        // 判断是否 Firefox浏览器
        if (userAgent.indexOf('Firefox') > -1) {
          openApp = true
        }
        // 判断是否 Chrome浏览器
        if (userAgent.indexOf('Chrome') > -1) {
          openApp = true
        }
        // 判断是否 Edge浏览器
        if (userAgent.indexOf('Edg') > -1) {
          openApp = true
        }
        if (openApp) {
          try {
            this.openUriWithInputTimeoutHack(
              process.env.VUE_APP_XR_NAME + '://' + encodeURIComponent(JSON.stringify(data)),
              error => {
                this.visible = true
                console.log('error ----->', error)
              },
              success
            )

            // 向客户端发送scoket消息
            const scoketData = {
              opcode: 'message',
              message_id: '306',
              data: {
                to: 'teacher_' + cookie.getJSON('user_infor').id,
                body: {
                  name: 'web_to_client',
                  from: cookie.getJSON('user_infor').id,
                  type: 'teach',
                  content: JSON.stringify({
                    resId: this.getOriginalId(obj.id),
                    roomId: this.roomId,
                    playerId: obj.playerInfo.find(playItem => playItem.playerType === 'teach').playerId,
                    source_type: obj.sourceType || 'school'
                  })
                }
              }
            }
            vrClicent.sendMessage(scoketData)
            window.addEventListener('blur', () => {})
            window.addEventListener('focus', () => {})
          } catch (err) {
            console.log(err)
            this.$message.warning('出错了，请手动打开软件！')
          }
        }
      }
    },
    closeTeach(obj) {
      this.teachInfo = Object.assign(this.teachInfo, {
        id: '',
        isTeach: false
      })
      // 关闭学生端示教
      const closeResData = {
        opcode: 'event',
        message_id: '503',
        data: {
          name: 'CloseRes',
          content: {
            name: 'CloseRes',
            roomId: this.roomId,
            open_type: 'teach'
          }
        }
      }
      vrClicent.sendMessage(closeResData)

      // 关闭老师端示教
      const scoketData = {
        opcode: 'message',
        message_id: '306',
        data: {
          to: 'teacher_' + cookie.getJSON('user_infor').id,
          body: {
            name: 'web_to_client',
            from: cookie.getJSON('user_infor').id,
            type: 'CloseTeach',
            content: JSON.stringify({
              resId: this.getOriginalId(obj.id),
              roomId: this.roomId,
              playerId: obj.playerInfo.find(playItem => playItem.playerType === 'teach').playerId
            })
          }
        }
      }
      vrClicent.sendMessage(scoketData)
      this.$message.success('系统关闭中...')
    },
    // 打开应用程序
    openUriWithInputTimeoutHack(url, failCb, successCb) {
      const target = document.createElement('input')
      target.style.width = '0'
      target.style.height = '0'
      target.style.position = 'fixed'
      target.style.top = '0'
      target.style.left = '0'
      document.body.appendChild(target)

      target.focus()
      const handler = this.registerEvent(target, 'blur', onBlur)

      function onBlur() {
        successCb && successCb()
        handler.remove()
        clearTimeout(timeout)
        document.body.removeChild(target)
      }

      location.href = url

      const timeout = setTimeout(function() {
        failCb && failCb()
        handler.remove()
        document.body.removeChild(target)
      }, 1000)
    },
    registerEvent(target, eventType, cb) {
      if (target.addEventListener) {
        target.addEventListener(eventType, cb)
        return {
          remove: function() {
            target.removeEventListener(eventType, cb)
          }
        }
      } else {
        target.attachEvent(eventType, cb)
        return {
          remove: function() {
            target.detachEvent(eventType, cb)
          }
        }
      }
    },
    getPermission() {
      const permissionList = localStorage.getItem('permissionList')
      if (permissionList.includes('training')) {
        this.isTeachPer = true
      }
    },
    // 获取原始id
    getOriginalId(id) {
      return id.includes('_') ? id.split('_')[1] : id
    }
  },
  mounted() {
    this.roomId = this.$route.query.id
    this.timer = setInterval(() => {
      this.getLessonMonitor()
    }, 3000)
    this.webSockerTimer = setInterval(() => {
      const pingData = {
        opcode: 'ping'
      }
      vrClicent.sendMessage(pingData)
    }, 30000)
    this.getLessonDetail()
    const wsUrl =
      process.env.NODE_ENV === 'development' || window.location.origin === 'https://pt.qa.growlib.com'
        ? 'wss://pt.qa.growlib.com/ws'
        : 'wss://ws.growlib.com/ws'
    vrClicent.connect(wsUrl, this.roomId)
    // 结束播控
    setTimeout(() => {
      this.close()
    }, 1000)
  },
  created() {
    this.getPermission()
  },
  destroyed() {
    clearInterval(this.webSockerTimer)
    clearInterval(this.timer)
    this.timer = null
    this.close('', false)
    setTimeout(() => {
      vrClicent.closeWebsocket()
    }, 2000)
  }
}
</script>

<style lang="less" scoped>
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
.content {
  height: 100%;
  display: flex;
  justify-content: space-between;
  .left {
    height: 100%;
    width: 260px;
    position: relative;
    padding: 18px 21px 46px 21px;
    .list-content {
      height: 100%;
      overflow-y: scroll;
      .list {
        color: #000;
        display: flex;
        flex-direction: column;
        .title {
          font-size: 16px;
          font-weight: 550;
          margin-bottom: 15px;
        }
        .child {
          height: 36px;
          display: flex;
          font-size: 14px;
          cursor: pointer;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 10px;
          padding: 6px 5px 6px 10px;
          img {
            width: 22px;
            height: 22px;
            border-radius: 5px;
          }
          span {
            color: #000;
            margin: 0 8px;
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            word-break: break-all;
            display: inline-block;
            text-overflow: ellipsis;
            width: calc(100% - 78px);
          }
          .icon-play,
          .icon-close {
            border: 0;
            width: 14px;
            height: 15px;
            display: none;
            // margin-right: 10px;
          }
          .icon-close {
            display: block;
          }
          &:last-child {
            margin-bottom: 40px;
          }
          .teach {
            margin-bottom: 0;
            .icon_teach {
              display: none;
            }
            > div {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              img {
                width: 18px;
                height: 18px;
              }
              div {
                font-size: 10px;
                color: #000;
              }
            }
          }
          .broadcasting {
            width: 23px;
            padding-left: 10px;
            box-sizing: border-box;
          }
          .action {
            width: 50px;
            padding-right: 5px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
        }
        .child:hover {
          background: #f9f3e1;
          .icon-play {
            display: block;
          }
          .teach {
            .icon_teach {
              display: block;
            }
          }
        }
        .child.selected {
          color: #000;
          font-weight: 550;
          background: #f9f3e1;
        }
      }
    }
    .list-content::-webkit-scrollbar {
      display: none;
    }
    .close-button {
      bottom: 22px;
      height: 46px;
      display: flex;
      cursor: pointer;
      padding-top: 12px;
      position: absolute;
      background: #fff;
      justify-content: center;
      width: calc(100% - 42px);
      > div {
        width: 98px;
        height: 34px;
        color: #000;
        display: flex;
        margin: 0 auto;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        border: 1px solid #d6d6d6;
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
    }
  }
  .right {
    width: calc(100% - 260px);
    height: 100%;
    /deep/.ant-tabs {
      height: 100%;
      color: #000;
      // padding: 0 26px 33px 0;
      .ant-tabs-bar.ant-tabs-top-bar {
        border-bottom: 0;
        margin-bottom: 0;
        padding-bottom: 10px;
        // padding-left: 25px;
        background: url('./../../../assets/img/bj_lesson_t.png');
        background-size: 100% 100%;
        background-position: center;
        .ant-tabs-tab {
          color: #000;
          padding: 28px 27px 7px 0;
          &:first-child {
            padding-left: 25px;
          }
        }
        .ant-tabs-nav.ant-tabs-nav-animated > div {
          display: flex;
        }
        .ant-tabs-tab-active.ant-tabs-tab {
          display: flex;
          font-weight: 550;
          position: relative;
          justify-content: center;
          &::after {
            bottom: 0;
            content: '';
            width: 23px;
            height: 4px;
            border-radius: 3px;
            position: absolute;
            background: #ff6d00;
          }
        }
        .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
          display: none !important;
        }
      }
      .ant-tabs-content.ant-tabs-content-animated.ant-tabs-top-content {
        height: 100%;
      }
      .ant-tabs-tabpane-active {
        height: 100%;
        background: url('./../../../assets/img/bj_lesson_y.png');
        background-size: 100% 100%;
        background-position: center;
        // padding-left: 25px;
      }
    }
    /deep/.preview-container {
      width: 100%;
      height: 100%;
      padding: 0 25px;
      height: calc(100% - 88px);
      background: #fff;
      .preview {
        overflow-y: scroll;
      }
    }
    .monitor-attempts {
      height: 100%;
    }
    .data-overview {
      height: calc(100% - 56px);
      position: relative;
      .title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 550;
        color: #000000;
        line-height: 20px;
        padding: 18px 35px;
        position: relative;
        &::before {
          content: '';
          width: 2px;
          left: 26px;
          height: 10px;
          border-radius: 1px;
          position: absolute;
          background: #000000;
        }
      }
      .overview {
        display: flex;
        padding: 0 35px;
        margin-bottom: 6px;
        justify-content: space-between;
        > div {
          font-size: 14px;
          display: flex;
          color: #4a5474;
          margin-right: 10px;
          align-items: center;
          img {
            width: 64px;
            height: 64px;
            margin-right: 12px;
          }
          .number {
            color: #000;
            font-size: 16px;
          }
          span {
            color: #000;
          }
          &:last-child {
            margin-right: 0;
            > div div {
              display: flex;
              align-items: flex-end;
              justify-content: space-between;
              span:last-child {
                color: #767676;
                cursor: pointer;
                font-size: 12px;
                margin-left: 12px;
                padding-bottom: 2px;
                img {
                  width: 10px;
                  height: 6px;
                  transform: rotate(-90deg);
                }
              }
            }
          }
        }
      }
      .review {
        max-height: calc(100% - 240px);
        display: flex;
        flex-wrap: wrap;
        padding: 0 35px;
        overflow-y: scroll;
        .student {
          height: 215px;
          cursor: pointer;
          border-radius: 4px;
          margin-right: 22px;
          margin-bottom: 22px;
          position: relative;
          border-radius: 4px;
          width: calc((100% - 66px) / 4);
          .student-cover {
            width: 100%;
            height: 175px;
            border-radius: 4px;
            position: relative;
            img {
              width: 100%;
              height: 100%;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
            }
            .hover {
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              display: none;
              border-radius: 4px;
              position: absolute;
              background: rgba(0, 0, 0, 0.6);
            }
            &:hover .hover {
              display: flex;
              align-items: center;
              justify-content: center;
              /deep/.ant-btn.ant-btn-primary,
              /deep/.ant-btn.ant-btn-primary:hover {
                width: 100px;
              }
            }
          }
          // >span{
          //   font-size: 12px;
          //   font-weight: 400;
          //   color: #B3B3B3;
          //   line-height: 17px;
          // }
          .name {
            height: 40px;
            padding: 0 16px;
            font-size: 14px;
            overflow: hidden;
            color: #000000;
            font-weight: 550;
            line-height: 40px;
            text-align: center;
            white-space: nowrap;
            word-break: break-all;
            background: #ececec;
            text-overflow: ellipsis;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
          }
          &:nth-child(4n) {
            margin-right: 0;
          }
        }
      }
      .review::-webkit-scrollbar {
        display: none;
      }
      .list-pagination {
        width: 100%;
        bottom: 60px;
        position: absolute;
      }
    }
    .live-view {
      position: relative;
      height: calc(100% - 56px);
      background: url('./../../../assets/img/bj_sk.png');
      background-size: 100% 100%;
      background-position: center;
      .close-view {
        top: 21px;
        right: 30px;
        width: 22px;
        z-index: 9;
        cursor: pointer;
        font-size: 16px;
        position: absolute;
      }
      .title {
        z-index: 3;
        display: flex;
        font-size: 16px;
        font-weight: 550;
        color: #1def53;
        line-height: 22px;
        padding: 21px 25px;
        align-items: center;
        position: relative;
        span {
          width: 8px;
          height: 8px;
          margin-right: 10px;
          border-radius: 100%;
          background: #1def53;
          display: inline-block;
        }
      }
      video {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 10px;
        position: absolute;
      }
    }
    .no-monitor-attempts {
      display: flex;
      height: 100%;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      img {
        width: 180px;
        margin-top: -40px;
      }
      > div {
        font-size: 14px;
        font-weight: 800;
        color: #0d2340;
        line-height: 20px;
        text-align: center;
        margin-top: -40px;
        &:last-child {
          font-size: 12px;
          font-weight: 500;
          margin-top: 0;
        }
      }
    }
  }
}
.unonlineModal {
  .title {
    top: 0;
    left: 0;
    width: 100%;
    color: #000;
    font-size: 16px;
    font-weight: 550;
    position: absolute;
    padding: 17px 24px 13px;
    border-bottom: 1px solid #edeeef;
    .small {
      font-size: 14px;
    }
  }
  .unonlineStudent {
    max-height: 400px;
    overflow-y: scroll;
    margin-top: 52px;
    span {
      color: #000;
      cursor: pointer;
      overflow: hidden;
      margin-bottom: 12px;
      padding: 10px 15px;
      text-align: center;
      white-space: nowrap;
      margin-right: 21px;
      border-radius: 20px;
      display: inline-block;
      word-break: break-all;
      text-overflow: ellipsis;
      border: 1px solid #dbdbde;
      width: calc((100% - 63px) / 4);
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
  // .unonlineStudent::-webkit-scrollbar{
  //   display: none;
  // }
  /deep/.ant-modal-footer {
    .ant-btn {
      margin-left: 0;
    }
    .ant-btn:first-child {
      display: none;
    }
  }
}
</style>
